var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivate01 = function SvgActivate01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "activate-01_svg2__a",
    x1: 35.96,
    x2: 158.51,
    y1: 169.98,
    y2: 66.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M199.99 158.92c0 2.51-.38 5.01-1.13 7.41l-9.56 30.73a4.16 4.16 0 0 1-3.98 2.93q-.63 0-1.23-.18a4.16 4.16 0 0 1-2.74-5.22l9.56-30.74c2.72-8.74-2.16-18.04-10.9-20.77-.65-.2-1.31-.36-1.97-.48l-33.53-6.08a4.18 4.18 0 0 1-3.43-4.1v-48.6c-.13-3.89-3.39-6.93-7.28-6.8-3.7.13-6.67 3.1-6.8 6.8v85.94c0 2.3-1.87 4.17-4.17 4.17-1.1 0-2.16-.44-2.94-1.22l-15.53-15.54a7.57 7.57 0 0 0-10.71-.3 7.57 7.57 0 0 0-.3 10.71c.1.1.2.21.3.3l25 25a4.17 4.17 0 0 1 0 5.9 4.17 4.17 0 0 1-5.9 0l-25-25c-6.21-6.21-6.21-16.29 0-22.5s16.29-6.21 22.5 0l8.42 8.42V83.86c.2-8.49 7.24-15.21 15.73-15.01 8.21.19 14.82 6.8 15.01 15.01v45.13l30.11 5.46c11.84 2.15 20.44 12.45 20.46 24.48ZM115.72 55.06a4.16 4.16 0 0 0-5.89 0L70.48 94.42 52.15 76.09a4.16 4.16 0 0 0-5.89-.1 4.16 4.16 0 0 0-.1 5.89l.1.1 21.32 21.33a4.16 4.16 0 0 0 5.89 0L115.77 61a4.16 4.16 0 0 0 0-5.89l-.04-.04Zm-54.29 92.7C23.56 137.95.81 99.3 10.62 61.42 20.42 23.55 59.08.8 96.95 10.61a70.85 70.85 0 0 1 49.71 46.99c.7 2.19 3.05 3.4 5.24 2.7s3.4-3.05 2.7-5.24C141.27 13.42 96.71-9.54 55.07 3.79 13.42 17.11-9.53 61.68 3.79 103.32a79.15 79.15 0 0 0 55.55 52.51c.34.09.69.13 1.04.13 2.3.02 4.18-1.84 4.2-4.14.01-1.92-1.29-3.6-3.15-4.07Z",
    style: {
      fill: "url(#activate-01_svg2__a)"
    }
  }));
};
export default SvgActivate01;